








import { Component, Vue } from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import { throwExternalWindowPopup } from '@/pro/helpers/popup';

@Component({
  components: { AdminIframe, PageTitle },
})
export default class SmsRejectIframe extends Vue {
  private get remoteSrc() {
    const host = process.env.VUE_APP_ADMIN_REMOTE_URL;
    const { iframePath } = this.$route.meta;

    return host + iframePath + '?serviceType=PREMIUM';
  }

  private handleMessage({data, origin}) {
    if ((origin === process.env.VUE_APP_ADMIN_REMOTE_URL) && data.type === 'REQUEST_OPEN_REFUSAL_PROCESS') {
      const { url, data: postData } = data.data;
      throwExternalWindowPopup(url, 'new', postData);
    }
  }

  created() {
    window.addEventListener('message', this.handleMessage);
  }

  destroyed() {
    window.removeEventListener('message', this.handleMessage);
  }

 
}
